<template>
  <div class="body">
    <el-alert :closable="false">Após a geração do boleto aguarde algumas horas para realizar o pagamento</el-alert>
    <el-alert type="warning" :closable="false">O crédito será adicionado somente após a baixa do boleto no sistema
      bancário</el-alert>
    <el-form label-width="160px">
      <el-form-item label="Data de vencimento" prop="value">
        <el-date-picker v-model="ruleForm.dueAt" type="date" unlink-panels format="dd/MM/yyyy"></el-date-picker>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'PaymentBillet',
  data() {
    const today = new Date();
    return {
      ruleForm: {
        type: 'billet',
        dueAt: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1),
      }
    }
  },
  methods: {
    get() {
      return this.ruleForm;
    },
    validate() {
      return true;
    }
  }
}
</script>
